"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToNumber = stringToNumber;
function stringToNumber(stringNumber, defaultResult) {
    if (typeof stringNumber === 'string' && stringNumber) {
        stringNumber = parseInt(stringNumber.trim());
    }
    if (typeof stringNumber !== 'number' || isNaN(stringNumber)) {
        if (defaultResult === undefined) {
            throw new Error('Invalid number: ' + stringNumber);
        }
        return defaultResult;
    }
    return stringNumber;
}
//# sourceMappingURL=number.util.js.map